import React from 'react'

import { DELIVERY_TYPES } from 'constants/sales'
import CSSPlugin from 'gsapAlias/CSSPlugin'
import TweenLite from 'gsapAlias/TweenLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

const deliveryTypeAnimation = ({ dropdown, address, deliveryType }) => {
  TweenLite.to(dropdown, 0.6, {
    maxHeight: deliveryType === DELIVERY_TYPES.pickup ? 0 : 400,
    overflow: deliveryType === DELIVERY_TYPES.pickup ? 'hidden' : 'visible',
  })
  TweenLite.to(address, 0.6, {
    maxHeight: deliveryType === DELIVERY_TYPES.pickup ? 0 : 400,
    overflow: deliveryType === DELIVERY_TYPES.pickup ? 'hidden' : 'visible',
  })
}

export const useDeliveryTypeAnimation = ({
  dropdownRef,
  collapsedFields,
  deliveryType,
}) => {
  React.useEffect(() => {
    if (dropdownRef.current)
      deliveryTypeAnimation({
        dropdown: dropdownRef.current,
        address: collapsedFields.current,
        deliveryType,
      })
  }, [collapsedFields, deliveryType, dropdownRef])
}
